<template lang="pug">
  v-container.View
    template(v-if="!loading")
      v-card
        v-img.white--text(
          :src="location.coverImage"
          height="15rem"
          gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,.7)"
        )
          v-container(fill-height fluid)
            v-layout(fill-height align-end)
              .d-flex.align-center
                v-flex(xs12)
                  .subtitle-1 {{ categoryNameToPretty(location.mainCategory, this.categories) }}
                  .headline {{ location.name }}
        v-card-text(style="color:rgba(0, 0, 0, 0.87)")
          .text-title Pre-registrazione
          ValidationObserver(v-slot="{ invalid, validated, passes }" :immediate="$auth.check()")
            v-form
              v-layout(wrap)
                v-flex(xs12)
                  ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }" :immediate="$auth.check()")
                    v-text-field(
                      v-model="form.email"
                      :error-messages="errors"
                      name="e-mail" type="email"
                      label="Email" prepend-inner-icon="mdi-at"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Nome" rules="required" v-slot="{ errors }" :immediate="$auth.check()")
                    v-text-field(
                      v-model="form.name"
                      :error-messages="errors"
                      name="nome"
                      label="Nome" prepend-inner-icon="mdi-account"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }" :immediate="$auth.check()")
                    v-text-field(
                      v-model="form.surname"
                      :error-messages="errors"
                      name="cognome"
                      label="Cognome" prepend-inner-icon="mdi-account"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Telefono" rules="required" v-slot="{ errors }" :immediate="$auth.check()")
                    v-text-field(
                      v-model="form.phone"
                      :error-messages="errors"
                      name="telefono"
                      label="Telefono" prepend-inner-icon="mdi-phone"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Privacy" rules="required" v-slot="{ errors }")
                    v-checkbox(
                      v-model="form.privacy"
                      :error-messages="errors"
                      name="privacy"
                      :true-value="true"
                      :false-value="null"
                    )
                      template(slot="label")
                        span Acconsento al trattamento dei miei dati secondo la&nbsp;
                          a(href="#" @click="downloadPrivacyPolicy()") politica privacy
                v-flex(xs12)
                  v-btn.secondary(
                    @click="passes(preRegister)" :disabled="invalid || !validated"
                    :loading="loadingPreregister" block
                  ) Pre-registrati
    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import Location from "@/api/LocationPublic";
import Category from "@/api/Category";
import User from "@/api/User";
import Preregistration from "@/api/Preregistration";

import { categoryNameToPretty } from "@/utils/categoryUtils";

export default {
  name: "Location",
  components: { Loading },

  data: () => ({
    loading: true,
    loadingPreregister: false,

    location: null,
    categories: null,

    form: {
      email: "",
      name: "",
      surname: "",
      phone: "",
      privacy: false
    }
  }),

  async mounted() {
    this.loading = true;

    this.location = await Location.get(this.$route.params.place);
    this.$emit("update:title", `${this.location.name} - Pre-registrazione`);
    this.categories = await Category.all();

    if (this.$auth.check()) {
      const user = await User.getProfile();
      this.form.name = user.name;
      this.form.surname = user.surname;
      this.form.email = user.email;
      this.form.phone = user.phone;
    }
    this.loading = false;
  },

  methods: {
    categoryNameToPretty,
    async preRegister() {
      this.loadingPreregister = true;
      let response;
      if (this.$auth.check()) {
        response = await Preregistration.create({
          locationId: this.$route.params.place
        });
      } else {
        response = await Preregistration.createUnauthenticated({
          ...this.form,
          locationId: this.$route.params.place
        });
      }
      this.$router.push({
        name: "ticket-preregister",
        params: {
          preregistration: response.id,
          place: this.$route.params.place
        }
      });
      this.loadingPreregister = false;
    },
    async downloadPrivacyPolicy() {
      // it's an hack
      this.loadingPreregister = true;
      const response = await this.axios.get(
        `public/locations/${this.location.id}/privacy-policy-pdf`,
        {
          responseType: "arraybuffer",
          headers: {
            Accept: "application/pdf"
          }
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "PRIVACY-POLICY.pdf";
      link.click();
      this.loadingPreregister = false;
    }
  }
};
</script>
